import { LockOutlined } from '@mui/icons-material';
import { Avatar, Box, Button, Container, TextField, Typography } from '@mui/material';
import CenterBox from '@/components/CenterBox';
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { loginUser } from '@/store/auth/authThunks';
import { useToastError } from '@/hooks/useToastError';
import { useTranslation } from 'react-i18next';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const dispatch = useDispatch();
  const navigate = useNavigate();
  // @ts-ignore
  const { token } = useSelector(state => state.auth);
  const error = useSelector(state => state.auth.error);

  const { t } = useTranslation();

  useToastError(error, t('login.error'), false);

  useEffect(() => {
    if (token) {
      navigate('/dashboard');
    }
  }, [token, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    // @ts-ignore
    dispatch(loginUser({ loginname: username, password }));
  };

  return (
    <Container component="main" maxWidth="xs">
      <CenterBox>
        <Avatar sx={{
          margin: 1,
          mt: 2,
        }}
        >
          <LockOutlined />
        </Avatar>
        <Typography component="h1">
          {t('login.title')}
        </Typography>
      </CenterBox>
      <Box component="form" onSubmit={handleSubmit} noValidate>
        <TextField
          margin="normal"
          required
          fullWidth
          id="username"
          label={t('login.username')}
          name="username"
          autoFocus
          value={username}
          onChange={e => setUsername(e.target.value)}
        />
        <TextField
          margin="normal"
          required
          fullWidth
          id="password"
          label={t('login.password')}
          name="password"
          value={password}
          type="password"
          onChange={e => setPassword(e.target.value)}
        />
        <Button type="submit" fullWidth variant="contained">
          {t('login.title')}
        </Button>
      </Box>
    </Container>
  );
};

export default Login;
